var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61311 1.75C2.13643 1.75 1.75 2.13643 1.75 2.61311V15.518C1.75 15.9947 2.13643 16.3811 2.61311 16.3811H17.9377C18.4144 16.3811 18.8008 15.9947 18.8008 15.518V2.61311C18.8008 2.13643 18.4144 1.75 17.9377 1.75H2.61311ZM0.25 2.61311C0.25 1.308 1.308 0.25 2.61311 0.25H17.9377C19.2428 0.25 20.3008 1.308 20.3008 2.61311V15.518C20.3008 16.8231 19.2428 17.8811 17.9377 17.8811H2.61311C1.308 17.8811 0.25 16.8231 0.25 15.518V2.61311Z",
    fill: "#00842F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 4.28125H20.3008V5.78125H0.25V4.28125Z",
    fill: "#00842F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.414 2.38281C6.52795 2.38281 6.63933 2.4166 6.73407 2.4799C6.82881 2.54321 6.90265 2.63318 6.94626 2.73845C6.98986 2.84373 7.00127 2.95956 6.97904 3.07132C6.95681 3.18307 6.90194 3.28572 6.82137 3.36629C6.7408 3.44687 6.63815 3.50174 6.5264 3.52396C6.41464 3.54619 6.2988 3.53479 6.19353 3.49118C6.08826 3.44758 5.99829 3.37373 5.93498 3.27899C5.87168 3.18425 5.83789 3.07287 5.83789 2.95892C5.83789 2.80613 5.89859 2.65959 6.00663 2.55155C6.11467 2.44351 6.26121 2.38281 6.414 2.38281Z",
    fill: "#00842F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99603 2.38281C4.10998 2.38281 4.22136 2.4166 4.3161 2.4799C4.41084 2.54321 4.48469 2.63318 4.52829 2.73845C4.57189 2.84373 4.5833 2.95956 4.56107 3.07132C4.53884 3.18307 4.48398 3.28572 4.40341 3.36629C4.32283 3.44687 4.22018 3.50174 4.10843 3.52396C3.99667 3.54619 3.88084 3.53479 3.77557 3.49118C3.67029 3.44758 3.58032 3.37373 3.51701 3.27899C3.45371 3.18425 3.41992 3.07287 3.41992 2.95892C3.41992 2.80613 3.48062 2.65959 3.58866 2.55155C3.6967 2.44351 3.84324 2.38281 3.99603 2.38281Z",
    fill: "#00842F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83588 2.38281C8.94982 2.38281 9.06121 2.4166 9.15595 2.4799C9.25069 2.54321 9.32453 2.63318 9.36813 2.73845C9.41174 2.84373 9.42315 2.95956 9.40092 3.07132C9.37869 3.18307 9.32382 3.28572 9.24325 3.36629C9.16268 3.44687 9.06003 3.50174 8.94827 3.52396C8.83652 3.54619 8.72068 3.53479 8.61541 3.49118C8.51014 3.44758 8.42016 3.37373 8.35686 3.27899C8.29355 3.18425 8.25977 3.07287 8.25977 2.95892C8.25977 2.80613 8.32046 2.65959 8.4285 2.55155C8.53655 2.44351 8.68308 2.38281 8.83588 2.38281Z",
    fill: "#00842F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.dfbeba5f.svg";
export { ForwardRef as ReactComponent };